import { EyedropperIcon } from "@phosphor-icons/react";
import { AggregationColor } from "./colorTypes";
import { useAntTheme } from "hooks/useAntTheme/";
import { useCallback } from "react";

export const EyeDropper = ({
  handleChangeComplete,
}: {
  handleChangeComplete: (color: AggregationColor) => void;
}) => {
  const { theme } = useAntTheme();
  const handleEyedropperClick = useCallback(() => {
    void (async () => {
      try {
        const eyeDropper = new globalThis.EyeDropper();
        const result = await eyeDropper.open();
        handleChangeComplete(new AggregationColor(result.sRGBHex));
      } catch (error) {
        console.error(error);
      }
    })();
  }, [handleChangeComplete]);
  if ("EyeDropper" in globalThis) {
    return (
      <EyedropperIcon
        data-testid="eyedropper-icon"
        size={22}
        color={theme.colorTextSecondary}
        onClick={handleEyedropperClick}
        style={{ cursor: "pointer" }}
      />
    );
  }
  return null;
};
